import { Link } from "react-router-dom"
import { getCampaigns } from "../../api/axios"
import { useState, useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import LoadingContainer from "../../components/LoadingContainer";
import { getBrandClassName } from "../../utilities/Utils";


const CampaignsTable = (props) => {

  const [isLoading, setIsLoading] = useState(true);
  const [campaigns, setCampaigns] = useState(null);

// https://www.robinwieruch.de/react-hooks-fetch-data/

  const { auth } = useAuth();

  useEffect(() => {

    const fetchData = async () => {
      
      try {
        
        const data = await getCampaigns({props, auth});
        setCampaigns(data.results);

      } catch (error) {

        setCampaigns(null);

      }

      setIsLoading(false); 

    };

    fetchData();

  }, [props, auth]);

  

  const hasCampaigns = Array.isArray(campaigns) && campaigns.length > 0;

  return (

    <LoadingContainer isLoading={isLoading}>
      
      <table className="table table--enhanced">
                      
        <thead>
            <tr>
                <td>ID / Marca</td> 
                <td>Nombre</td> 
            </tr>
        </thead>
        <tbody>
            {!isLoading && !hasCampaigns && (
              <tr><td colSpan="2" className="c loading">No se encontraron campañas</td></tr>
            )}
            {!isLoading && hasCampaigns && campaigns.map( item => (

              <tr key={item.id}>
                  
                  <td>
                    <div className="table-identity">
                    <Link className="vinculo table-id-pill" to={`/campaigns/edit/${item.id}`}>{item.id}</Link>
                    <span className={getBrandClassName(item.brand_name, 'table-brand-label')}>{item.brand_name}</span>
                    </div>
                  </td>
                  <td>
                    <span className="table-primary">{item.name}</span>
                  </td>
                  
              </tr>
            ))}
            
        </tbody>

      </table>
    </LoadingContainer>
    
    )
}

export default CampaignsTable
